import { render, staticRenderFns } from "./findPassword.vue?vue&type=template&id=090ffc26&scoped=true"
import script from "./findPassword.vue?vue&type=script&lang=ts"
export * from "./findPassword.vue?vue&type=script&lang=ts"
import style0 from "./findPassword.vue?vue&type=style&index=0&id=090ffc26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090ffc26",
  null
  
)

export default component.exports